import _slicedToArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { disposables as s } from '../../utils/disposables.js';
import { createStore as i } from '../../utils/store.js';
import { adjustScrollbarPadding as l } from './adjust-scrollbar-padding.js';
import { handleIOSLocking as d } from './handle-ios-locking.js';
import { preventScroll as p } from './prevent-scroll.js';

function m(e) {
  var n = {};

  var _iterator = _createForOfIteratorHelper(e),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var t = _step.value;
      Object.assign(n, t(n));
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return n;
}

var a = i(function () {
  return new Map();
}, {
  PUSH: function PUSH(e, n) {
    var o;
    var t = (o = this.get(e)) != null ? o : {
      doc: e,
      count: 0,
      d: s(),
      meta: new Set()
    };
    return t.count++, t.meta.add(n), this.set(e, t), this;
  },
  POP: function POP(e, n) {
    var t = this.get(e);
    return t && (t.count--, t.meta.delete(n)), this;
  },
  SCROLL_PREVENT: function SCROLL_PREVENT(_ref) {
    var e = _ref.doc,
        n = _ref.d,
        t = _ref.meta;
    var o = {
      doc: e,
      d: n,
      meta: m(t)
    },
        c = [d(), l(), p()];
    c.forEach(function (_ref2) {
      var r = _ref2.before;
      return r == null ? void 0 : r(o);
    }), c.forEach(function (_ref3) {
      var r = _ref3.after;
      return r == null ? void 0 : r(o);
    });
  },
  SCROLL_ALLOW: function SCROLL_ALLOW(_ref4) {
    var e = _ref4.d;
    e.dispose();
  },
  TEARDOWN: function TEARDOWN(_ref5) {
    var e = _ref5.doc;
    this.delete(e);
  }
});
a.subscribe(function () {
  var e = a.getSnapshot(),
      n = new Map();

  var _iterator2 = _createForOfIteratorHelper(e),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var _step2$value = _slicedToArray(_step2.value, 1),
          t = _step2$value[0];

      n.set(t, t.documentElement.style.overflow);
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  var _iterator3 = _createForOfIteratorHelper(e.values()),
      _step3;

  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var _t = _step3.value;
      var o = n.get(_t.doc) === "hidden",
          c = _t.count !== 0;
      (c && !o || !c && o) && a.dispatch(_t.count > 0 ? "SCROLL_PREVENT" : "SCROLL_ALLOW", _t), _t.count === 0 && a.dispatch("TEARDOWN", _t);
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }
});
export { a as overflows };